import React, { useEffect } from "react";
import { Control, FieldValues, useForm } from "react-hook-form";
import SelectField from "components/UI/SelectField";
import { SelectFieldOption } from "components/UI/SelectField/SelectField.type";
import { UNIT_FIELD_VAL_NAMES } from "constant/dl_unit/dl_unit_field.constant";

type UnitFieldValNameSelectProps<T extends FieldValues = FieldValues> = {
  control?: Control<T>;
  defaultValue?: string;
  label?: string;
  name?: string;
  onSelect?: (value: string) => void;
};

const FIELD_NAME_SELECT_OPTIONS: SelectFieldOption[] = UNIT_FIELD_VAL_NAMES.map(
  (fieldName: string) => {
    return {
      value: fieldName,
      label: fieldName.replace("_", " "),
    };
  },
);

const UnitFieldValNameSelect = <T extends FieldValues = FieldValues>({
  control,
  defaultValue = UNIT_FIELD_VAL_NAMES[0],
  label = "Polje",
  name = "uType",
  onSelect,
}: UnitFieldValNameSelectProps<T>) => {
  const { control: localControl, reset } = useForm({
    defaultValues: {
      [name]: defaultValue,
    },
  });

  useEffect(() => {
    if (!control) {
      reset({
        [name]: defaultValue,
      });
    }
  }, [control, defaultValue, name, reset]);

  return (
    <>
      <SelectField
        name={name}
        control={(control ?? localControl) as Control<any>}
        label={label}
        defaultValue={defaultValue}
        options={FIELD_NAME_SELECT_OPTIONS}
        onSelect={onSelect}
      />
    </>
  );
};

export default UnitFieldValNameSelect;
